import { BreachEvent } from '@news-mono/web-common'
import { BreachWallContentType } from './components/BreachNotificationWrapper/BreachNotificationWrapper'
import { SubscriptionPackageProps } from './components/SubscriptionPackage/SubscriptionPackage'

type BreachPackage = Omit<
    SubscriptionPackageProps,
    'breachCreativeName' | 'breachDeal' | 'articleId' | 'onEvent'
>

const base50percentDiscountPackage: BreachPackage[] = [
    {
        packageTheme: 'red',
        packagePath: 'subscribe/new',
        pretitle: 'Digital',
        heading: 'Everyday Digital',
        price: '50c per day',
        originalPrice: '$1 per day',
        priceQualifier: 'for 8 weeks*',
        packageType: 'digital',
        ribbonTitle: '50% off',
        offerCode: 'WKEND+DIG',
    },
    {
        pretitle: 'Digital & Print',
        heading: 'Weekend Papers + Everyday Digital',
        price: '$9 per week',
        packagePath: 'subscribenow/sat-sun+digital',
        packageType: 'digitalprint',
    },
]

export const breachPackages: Record<BreachWallContentType, BreachPackage[]> = {
    default: [
        {
            packagePath: 'subscribe/new',
            pretitle: 'Digital',
            heading: 'Everyday Digital',
            price: '$1 per day',
            packageType: 'digital',
        },
        {
            ribbonTitle: 'Most popular',
            pretitle: 'Digital & Print',
            heading: 'Weekend Papers + Everyday Digital',
            price: '$9 per week',
            packagePath: 'subscribenow/sat-sun+digital',
            packageType: 'digitalprint',
        },
    ],
    'black-friday': [
        {
            packagePath: 'offercheck/thewest',
            offerCode: 'BLKFRI1',
            pretitle: 'Digital',
            originalPrice: '$1 a day',
            heading: 'Everyday Digital',
            price: '50c per day',
            priceQualifier: 'for 8 weeks*',
            packageType: 'digital',
        },
        {
            ribbonTitle: 'Most popular',
            pretitle: 'Digital & Print',
            heading: 'Weekend Papers + Everyday Digital',
            originalPrice: '$9 per week',
            price: '$4.50 per week',
            priceQualifier: 'for 8 weeks*',
            packagePath: 'offercheck/thewest',
            offerCode: 'BLKFRI2',
            packageType: 'digitalprint',
        },
    ],
    '50-off-breach-discount-coviddig': base50percentDiscountPackage,
    '50-off-breach-discount-govan50': base50percentDiscountPackage,
    '50-off-breach-discount-printdig': [
        {
            packageTheme: 'red',
            pretitle: 'Digital & Print',
            heading: 'Mon-Sun Papers + Everyday Digital',
            originalPrice: '$15.10 per week',
            price: '$1 per day',
            priceQualifier: 'for 8 weeks*',
            ribbonTitle: 'Limited Offer',
            packagePath: 'subscribenow/mon-sun+digital',
            packageType: 'digitalprint',
            offerCode: 'BRE1DISC',
        },
        {
            packagePath: 'subscribe/new',
            pretitle: 'Digital',
            price: '$1 per day',
            heading: 'Everyday Digital',
            packageType: 'digital',
        },
    ],

    sport: [],
}

export function packageOfferDetails(
    type: BreachWallContentType,
    breachCreativeName: string,
    breachDeal: string,
    onEvent: (event: BreachEvent) => void,
    articleId: string | undefined,
): SubscriptionPackageProps[] {
    const packages: SubscriptionPackageProps[] = []

    switch (type) {
        case '50-off-breach-discount-coviddig':
        case '50-off-breach-discount-govan50':
            breachPackages['50-off-breach-discount-coviddig'].forEach(
                (pack) => {
                    packages.push({
                        ...pack,
                        articleId: articleId,
                        breachCreativeName: breachCreativeName,
                        breachDeal: breachDeal,
                        onEvent: onEvent,
                    })
                },
            )
            break

        default:
            breachPackages[type].forEach((pack) => {
                packages.push({
                    ...pack,
                    articleId: articleId,
                    breachCreativeName: breachCreativeName,
                    breachDeal: breachDeal,
                    onEvent: onEvent,
                })
            })
            break
    }

    return packages
}
